import { rem } from "polished";
import styled from "styled-components";

export const SpeakerList = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: -${rem(12)} -${rem(5)} 0;
`;
